<template>
  <div class="container">
    <el-row>
      <el-col :span="24">
        <div class="demo-block demo-box demo-zh-CN demo-form" >
        <el-form ref="form"  label-width="90px">
          <el-form-item label="支付金额：">
            <el-input value="0.01" >0.01</el-input>
          </el-form-item>
          <el-button type="primary" @click="onSubmit">立即支付</el-button>
        </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'PayTest',
  methods: {
    onSubmit: function () {
      var v = getCookie('openid')
      alert('openid' + v)
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>
<style scoped>

  .container {
    margin-top: 24px;
  }
  .demo-box {
    padding: 30px;
    background-color: #fff;
  }
  .demo-block {
    border: 1px solid #ebebeb;
    border-radius: 3px;
    transition: .2s;
  }
  .formdiv {
    padding: 36px;
  }
</style>



// WEBPACK FOOTER //
// src/wx/PayTest.vue